// extracted by mini-css-extract-plugin
module.exports = {"roles-placeholder":"roles-placeholder___2RsHC"};